module.exports = __webpack_public_path__ + "static/media/1025564.f69cc063.jpg";